import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { PowerBIIcon, PowerBIIconBorderless, PowerBISearchResultIcon } from './icon';

export const powerBIConfig: ThirdPartyConfig = {
	displayName: 'PowerBI',
	id: 'power-bi',
	resourceType: ProductResourceTypes3P.PowerBI,
	icon: get3PLogo(PowerBIIcon, 'PowerBI', 'medium'),
	iconBorderless: get3PLogo(PowerBIIconBorderless, 'PowerBI', 'small'),
	searchResultIcon: get3PLogo(PowerBISearchResultIcon, 'PowerBI', 'large'),
	integrationAri: 'ari:cloud:platform::integration/microsoft',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Dashboard,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Dashboard],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
